export default "__VITE_ASSET__55cac4cf__"